window.OddData = {
  OddDataList: {},
  setOddData(key, value) {
    this.OddDataList[key] = value;
  },
  clear() {
    this.OddDataList = {};
  },
};
